import { useEffect } from 'react';
import apiService from '../services/api';
import { ServiceType } from '../services/api';
import { FutureInstrument } from '../types';

const coreService = apiService.getService(ServiceType.CORE);

interface UseDefaultFuturePriceOptions {
  setSelectedFuture: (future: FutureInstrument | null) => void;
}

/**
 * Hook to load and set the default future instrument on mount
 */
export const useDefaultFuturePrice = ({ setSelectedFuture }: UseDefaultFuturePriceOptions) => {
  useEffect(() => {
    const loadDefaultFuture = async () => {
      try {
        const response = await coreService.get('/search/futures?q=');

        if (response.data.results && response.data.results.length > 0) {
          const firstResult = response.data.results[0];
          const priceResponse = await coreService.get(`/price/latest/${firstResult.symbol}`);

          // Create FutureInstrument with real data
          const defaultFuture: FutureInstrument = {
            symbol: firstResult.symbol,
            name: firstResult.symbol,
            price: priceResponse.data.price || 0,
            volume: priceResponse.data.volume || 0,
            openInterest: 0,
            expiryDate: firstResult.maturityDate,
            change24h: firstResult.latestChange || 0,
            changePercent24h: priceResponse.data.changePercent || priceResponse.data.ref_diff_pct || 0
          };

          setSelectedFuture(defaultFuture);
        }
      } catch (error) {
        console.error('Error loading default future:', error);
        // No fallback - just log the error
      }
    };

    loadDefaultFuture();
  }, [setSelectedFuture]);
};



